import React, { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import {
	FORGOT_PASSWORD_FORM_FIELDS, FORGOT_PASSWORD_FORM_FIELDS_NAMES,
	forgotPasswordConfirmInitialValues, getForgotPasswordConfirmDetailSchema,
	getFormattedForgotPasswordConfirmFormFields,
} from '../../constants/forgot-password/forgot-password-form';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { executeRecaptcha } from '../../views/login/Login';
import { sendSentryMessage } from '../../utils/sentry-helper';
import { InputType } from '../form/form-input-constants';
import { FormInput } from '../merchants/FormInput';
import { ConfirmPasswordInput } from '../comfirmPassword/ConfirmPasswordInput';
import { CHANGE_PASS_INPUTS } from '../../constants/forgot-password/confirm-password-inputs';
import { confirmNewPassword } from '../../store/identyti/actions/forgot-password';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { IModalWindow, ModalWindow } from '../modal/ModalWindow';

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const ForgotPasswordConfirmFormOld: FC = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { search } = useLocation();

	const [loading, setLoading] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const [showCode, setShowCode] = useState(false);
	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});

	const email = new URLSearchParams(search)
		?.get('email')
		?.replace(' ', '+');

	const formik = useFormik({
		initialValues: forgotPasswordConfirmInitialValues,
		validationSchema: getForgotPasswordConfirmDetailSchema(t),
		onSubmit: async () => {
			if (!formik.isValid) return;

			try {
				setLoading(true);
				const recaptchaToken = await executeRecaptcha();

				const formattedValues = getFormattedForgotPasswordConfirmFormFields(formik.values);

				const params = {
					...formattedValues,
					recaptchaToken
				};

				await confirmNewPassword(params);

				setLoading(false);
				successModal();
				// navigate(`${pathname}?step=3`);

			} catch (e) {
				console.log('forgotPassword error', e.response);
				sendSentryMessage({ name: `POST confirm password error`, context: e });

			} finally {
				setLoading(false);
			}
		}
	});

	const successModal = (): void => {
		setModalState({
			isOpen: true,
			modalTitle: 'Reset password',
			content: (
				<div className="px-8 pb-10">
					<FontAwesomeIcon icon={faCircleCheck} width={36} className="h-36px mx-auto d-block my-7 text-muted"/>

					<div className="fs-2 fw-bolder my-5 text-center">Your password has been reset!</div>
					<div className="fs-6 mb-10 text-center">Your can now sign in again with your new password.</div>

					<ButtonComponent
						buttonType={BUTTON_TYPE.DEFAULT_BLACK}
						buttonName={t('FORGOT_PASSWORD.MODAL_BTN_NAME')}
						additionalClass="no-letter-spacing mt-10 mx-auto d-block"
						onButtonClick={(): void => navigate('/auth/login')}
					/>
				</div>
			),
			minHeight: 100,
			onClose: () => navigate('/auth/login')
		});
	};

	useEffect(() => {
		const script = document.createElement('script');
		script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
		document.body.appendChild(script);

		if (email) {

			formik.setFieldValue(FORGOT_PASSWORD_FORM_FIELDS.EMAIL, email);
		}
	}, []);

	const INPUTS = CHANGE_PASS_INPUTS({ showPassword, setShowPassword, showCode, setShowCode });

	return (
		<>
			<h1 className="fw-bolder text-center mb-10 fs-1">Set a new password</h1>
			<form
				onSubmit={formik.handleSubmit}
				className="form confirm-password-form-container"
			>
				<FormInput
					formik={formik}
					fieldName={FORGOT_PASSWORD_FORM_FIELDS.EMAIL}
					placeholder={t(FORGOT_PASSWORD_FORM_FIELDS_NAMES.EMAIL)}
					label={t(FORGOT_PASSWORD_FORM_FIELDS_NAMES.EMAIL)}
					inputType={InputType.Text}
					additionalClasses="col-12 col-sm-12 col-md-12 mb-10"
					required
				/>

				{
					INPUTS.map(input => (
						<ConfirmPasswordInput
							{...input}
							key={input.key}
							formik={formik}
							required
							isSmallInput
						/>
					))
				}

				<ButtonComponent
					buttonName="Confirm password"
					type="submit"
					buttonType={BUTTON_TYPE.DEFAULT_BLACK}
					isDisabled={loading}
					loading={loading}
					additionalClass="w-100"
				/>
			</form>

			<ModalWindow
				{...modalState}
			/>
		</>
	);
};
